import axios from 'axios'

const state = {
  domains: null
}

const getters = {
  StateDomains: state => state.domains,

  GetDomain: (state) => (id) => {
    return axios
    .get('domains/' + id)
    .then(response => response.data)
    .catch(error => { throw(error) })
    .finally(() => {
      //dispatch('GetDomains')
    })  
  }
}

const actions = {
  async CreateDomain ({ dispatch }, domain) {
    return axios
      .post('domains', domain)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetDomains')
      })

    //await axios.post('domains', domain)
    //await dispatch('GetDomains')
  },
  async UpdateDomain ({ dispatch }, domain) {
    return axios
      .put('domains/' + domain.id, domain)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetDomains')
      })

    //await axios.post('domains', domain)
    //await dispatch('GetDomains')
  },
  async DeleteDomain ({ dispatch }, domain) {
    return axios
      .delete('domains/' + domain.id)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        //dispatch('GetDomains')
      })

    //await axios.post('domains', domain)
    //await dispatch('GetDomains')
  },
  async GetDomains ({ commit }, params) {
    const response = await axios.get('domains', {params: params})
    commit('setDomains', response.data)
    //console.log(response.data)
  },
}

const mutations = {
  setDomains (state, domains) {
    state.domains = domains
  },
  setCurrentDomain (state, domain) {
    state.current_domain = domain
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}